<template>
  <div class="asso-team-portal">
    <ManageTeams :eventId="eventId" :association_id="association_id" :eventName="eventName" />
    <TournamentAddGameModal :association_id="association_id" :eventId="eventId" />
    <div class="asso-sec-content">
      <div class="d-flex align-items-center"
        :class="{ 'justify-content-between': joinedTeams.length > 0, 'justify-content-end': joinedTeams.length == 0 }"
        v-if="currentIsAdmin == '1'">
        <div class="count-wrap" v-if="joinedTeams.length > 0">{{ joinedTeams.length }} <span>{{ joinedTeams.length > 1 ?
          'teams' : 'team' }}</span></div>
        <button class="btn manage-btn" @click="manageTeams()">Manage Teams</button>
      </div>

      <div v-if="joinedTeams.length > 0">
        <div v-for="(teams, ageGroup) in groupedTeams" :key="ageGroup">
          <p class="count-wrap-sub">
            <span>{{ ageGroup }} </span>
            ({{ teams.length }} {{ teams.length > 1 ? 'Teams' : 'Team' }})
          </p>
          <div v-if="teams.length > 0">
            <div v-for="team in teams" :key="team.team.id"
              class="team-card d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="user-img">
                  <div class="users-notification" v-if="imgLoader == 1">
                    <img src="../../assets/loader.gif" alt="Loading..." />
                  </div>
                  <img @load="onImageLoad" v-if="team?.team?.team_avatar" :src="url + team?.team?.team_avatar" alt=""
                    class="team-avatar" />
                  <img @load="onImageLoad" v-else src="../../assets/Svg/people.svg" alt="" class="team-avatar" />
                </div>
                <div class="group-table-name pl-2">
                  <p>{{ team?.team?.team_name }}</p>
                  <span class="team-rating">{{ team?.team?.age_group?.name }} - {{ team?.team?.ratings?.rate }}</span>
                </div>
              </div>
              <div class="team-city">
                <p>
                  <img src="../../assets/Svg/location.svg" alt="location" class="pr-1" />
                  {{ team?.team?.city }}, {{ team?.team?.state }}
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="no-event-wrap" v-if="(!joinedTeams || joinedTeams.length == 0) && showLoaderTeam == 0">
        <img src="../../assets/Svg/no-data.svg" alt />
        <p class="header">No team found.</p>
        <p class="info">There are no team to display.</p>
      </div>

      <div class="products-list-shim p-0 mt-3" v-if="(!joinedTeams || joinedTeams.length == 0) && showLoaderTeam == 1">
        <content-placeholders :rounded="true">
          <content-placeholders-img />
          <content-placeholders-heading />
        </content-placeholders>
        <content-placeholders class="mt-3" :rounded="true">
          <content-placeholders-img />
          <content-placeholders-heading />
        </content-placeholders>
      </div>
    </div>

    <div class="asso-sec-content mt-3" v-if="tournamentsData.length > 0">
      <div class="d-flex justify-content-between flex-wrap align-items-center" style="gap: 5px;">
        <!-- Tournament Dropdown -->
        <div class="position-relative d-flex flex-wrap align-items-center" style="gap: 5px;">
          <div class="dropdown-wrapper">
            <div class="dropdown-button" :class="{
              'has-value': selectedTournamentName,
            }" @click="toggleDropdown" v-click-outside="closeDropdown">
              <div>
                <p class="association-data">{{ selectedTournamentName || "Division" }}</p>
              </div>
              <img :src="arrow_down" alt="arrow-down" />
            </div>

            <div class="dropdown-menu-content" v-if="activeDropdown">
              <input v-model="searchQuery" type="text" class="form-control" placeholder="Search Division" @click.stop
                @input="onSearchInput" />
              <div v-if="filteredTournaments.length === 0" class="no-results">No results found</div>
              <div class="dropdown-menu-content-inner" ref="dropdownMenu" v-else>
                <div v-for="tournament in filteredTournaments" :key="tournament.guid" class="dropdown-item"
                  @click="selectTournament(tournament)">
                  <span>{{ tournament.tournamentName }}</span>
                </div>
                <div class="position-relative py-3" v-if="showLoaderTournament === 1">
                  <div class="lds-dual-ring-media"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="dropdown-wrapper" v-click-outside="closeDropdownTeam">
            <button class="dropdown-button" :class="{
              'has-value': selectedTeams.length > 0,
            }" @click="toggleTeamDropdown">
              <span>{{
                selectedTeams.length >= 1
                  ? selectedTeams[0]
                  : "Teams"
              }}</span>
              <div class="badge-wrapper" v-if="selectedTeams.length > 1">
                <span class="counter-badge">+{{ selectedTeams.length - 1 }}</span>
              </div>
              <img :src="arrow_down" alt="arrow-down" />
            </button>
            <div class="dropdown-menu-content" v-show="teamDropdownOpen">
              <div v-if="showLoader" class="lds-dual-ring-refresh"></div>
              <div class="data-wrap" v-if="!showLoader">
                <input type="text" v-model="teamSearchQuery" placeholder="Search Teams" class="form-control" @click.stop @input="onSearchInputTeam" />
                <div class="dropdown-menu-content-inner">
                  <div v-if="filteredTeams.length === 0 && !showLoader" class="no-results">
                    No result found
                  </div>
                  <div v-else>
                    <div v-for="team in filteredTeams" :key="team.id" class="dropdown-item"
                      :class="{ selected: selectedTeams.includes(team.team.team_name) }"
                      @click="toggleTeamSelection(team)">
                      <input type="checkbox" :checked="selectedTeams.includes(team.team.team_name)"
                        class="checkbox circular-checkbox" />
                      <span>{{ team.team.team_name }}</span>
                    </div>
                  </div>
                </div>
                <!-- Clear Selection Button -->
                <button class="clear-btn" @click.stop="clearTeamSelection"
                  v-if="teamSearchQuery || selectedTeams.length > 0">
                  Clear Selection
                </button>
              </div>
            </div>
          </div>
          <div class="left-part-btns justify-content-start">
            <button :class="{ active: selectedFilter === 'all' }" @click="filterGames('all')">
              All
            </button>
            <button :class="{ active: selectedFilter === 'ongoing' }" @click="filterGames('ongoing')">
              Ongoing
            </button>
            <button :class="{ active: selectedFilter === 'final' }" @click="filterGames('final')">
              Final
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-end" v-if="currentIsAdmin == '1'">
          <button class="btn create-event" @click="callModal(selectedTournament)">
            Add Game
          </button>
        </div>
      </div>
      <TournamentGames ref="gameList" :currentIsAdmin="currentIsAdmin" :currentIsUmpire="currentIsUmpire"
        :tournamentData="tournamentsData" :showLoader="showLoaderTeam" :association_id="association_id"
        :associationId="associationId" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ManageTeams from './Modals/ManageTeams.vue';
import TournamentGames from "../Tournaments/TournamentGames.vue";
import TournamentAddGameModal from "../Tournaments/Modals/TournamentAddGameModal.vue";
export default {
  name: "AssociationTeamsInfo",
  components: {
    ManageTeams,
    TournamentGames,
    TournamentAddGameModal,
  },
  data() {
    return {
      searchQuery: "",
      url: this.$groupAvatarStorageURL,
      imgLoader: 1,
      gameOptions: false,
      selectedTournament: null,
      activeDropdown: false,
      previousScrollTop: 0,
      currentIsUmpire: "0",
      associationId: 0,
      arrow_down: require('@/assets/Svg/arrow-down.svg'),
      selectedFilter: localStorage.getItem("gameFilter") || "all", // Default filter

      teamData: [],
      selectedTeams: [],
      teamDropdownOpen: false,
      teamSearchQuery: '',
      teamLastPage: 1,
      search_icon: require('@/assets/Svg/Search.svg'),
    };
  },
  props: {
    tournamentsData: {
      type: Array,
    },
    eventId: {
      type: Number,
      required: true, // <-- must explicitly set to true
    },
    association_id: {
      type: Number,
      default: null, // optional: provide default if not required
    },
    joinedTeams: {
      type: Array
    },
    page: {
      type: Number
    },
    currentIsAdmin: {
      type: String,
    },
    eventName: {
      type: String,
    },
    lastPage: {
      type: Number
    },
    showLoaderTeam: {
      type: Number
    },
    showLoaderTournament: {
      type: Number,
    },
  },
  computed: {
    selectedTournamentName() {
      const tournament = this.tournamentsData.find(t => t.guid === this.selectedTournament);
      return tournament ? tournament.tournamentName : "";
    },
    groupedTeams() {
      const grouped = {};
      this.joinedTeams.forEach((team) => {
        const ageGroupName = team.team.age_group ? team.team.age_group.name : 'N/A';
        if (!grouped[ageGroupName]) {
          grouped[ageGroupName] = [];
        }
        grouped[ageGroupName].push(team);
      });

      // Sort age groups numerically
      const sortedGrouped = {};
      const sortedKeys = Object.keys(grouped).sort((a, b) => {
        // Extract numbers from the strings like "55 Older"
        const numA = parseInt(a);
        const numB = parseInt(b);
        return numA - numB;
      });

      sortedKeys.forEach((key) => {
        // Sort teams by team_name inside each group
        grouped[key].sort((a, b) => {
          const nameA = a.team.team_name.toLowerCase();
          const nameB = b.team.team_name.toLowerCase();
          return nameA.localeCompare(nameB);
        });
        sortedGrouped[key] = grouped[key];
      });

      return sortedGrouped;
    },
    sortedTournaments() {
      if (!this.tournamentsData) return [];
      return [...this.tournamentsData].sort((a, b) => {
        const nameA = (a.tournamentName || "").toUpperCase();
        const nameB = (b.tournamentName || "").toUpperCase();
        return nameA.localeCompare(nameB);
      });
    },
    filteredTournaments() {
      const query = this.searchQuery.trim().toLowerCase();
      return this.sortedTournaments.filter(t =>
        (t.tournamentName || '').toLowerCase().includes(query)
      );
    },
    filteredTeams() {
      const query = this.teamSearchQuery.trim().toLowerCase();
      return this.teamData.filter(team =>
        (team.team.team_name || '').toLowerCase().includes(query)
      );
    },
    selectedTeamNames() {
      return this.selectedTeams.map(teamId => {
        const team = this.teamData.find(t => t.id === teamId);
        return team ? team.team.team_name : '';
      }).join(', ');
    }
  },
  watch: {
    tournamentsData: {
      handler(newData) {
        if (!newData || newData.length === 0) return;

        // Create a sorted copy
        const sortedData = [...newData].sort((a, b) => {
          const nameA = (a.tournamentName || '').toUpperCase();
          const nameB = (b.tournamentName || '').toUpperCase();
          return nameA.localeCompare(nameB);
        });

        const storedTournamentID = localStorage.getItem("tournamentID");

        if (storedTournamentID) {
          this.selectedTournament = storedTournamentID;
          this.getTournamentTeams(storedTournamentID);
        } else {
          this.selectedTournament = sortedData[0].guid;
          localStorage.setItem("tournamentID", this.selectedTournament);
          this.getTournamentTeams(this.selectedTournament);
        }
      },
      immediate: true
    },
  },
  methods: {
    onSearchInput(e) {
      this.searchQuery = e.target.value;
    },
    onSearchInputTeam(e) {
      this.teamSearchQuery = e.target.value;
    },
    callModal(tournament) {
      this.$root.$emit("openTournamentAddGameModal", tournament);
    },
    onImageLoad() {
      this.imgLoader = 0;
    },
    openGameOptions() {
      this.gameOptions = !this.gameOptions;
    },
    onClickOutside() {
      this.gameOptions = false;
    },
    toggleDropdown() {
      this.searchQuery = '';
      this.activeDropdown = !this.activeDropdown;
      this.$nextTick(() => {
        if (this.activeDropdown && this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.addEventListener("scroll", this.onDropdownScroll);
        } else if (this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.removeEventListener("scroll", this.onDropdownScroll);
        }
      });
    },
    onDropdownScroll() {
      this.$emit("get-division-pagination");
    },
    closeDropdown() {
      this.activeDropdown = false;
    },
    toggleTeamDropdown() {
      this.teamDropdownOpen = !this.teamDropdownOpen;
    },

    toggleTeamSelection(team) {
      const teamName = team.team.team_name;
      const index = this.selectedTeams.indexOf(teamName);
      if (index === -1) {
        this.selectedTeams.push(teamName); // Store the full object
      } else {
        this.selectedTeams.splice(index, 1); // Remove by index
      }
      // Emit event with selected team names
      this.$root.$emit("filterGamesByTeams", this.selectedTeams);
    },

    clearTeamSelection() {
      this.selectedTeams = [];
      this.teamSearchQuery = '';
      this.$root.$emit("filterGamesByTeams", []);
    },

    closeDropdownTeam() {
      this.teamDropdownOpen = false;
    },

    async selectTournament(tournament) {
      this.selectedTournament = tournament.guid;
      this.teamData = []; // Clear existing teams data
      this.selectedTeams = []; // Clear selected teams
      this.page = 1;
      await this.getTournamentTeams(tournament.guid);
      this.$root.$emit("changeDivision", this.selectedTournament);
      localStorage.setItem("division", this.selectedTournament);
      this.closeDropdown();
    },
    async getJoinTeams() {
      this.joinedTeams = [],
        this.showLoader = 1;
      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/getJoinedTeam?page=${this.page}&event_id=${this.eventId}`;
        const response = await axios.get(url);
        if (response.data.statusCode === 200) {
          this.joinedTeams = response.data.data;

          this.showLoader = 0;
        } else {
          console.error(
            "Failed to fetch teams:",
            response.data.message || "Unknown error occurred"
          );
          this.showLoader = 0;
        }
      } catch (error) {
        this.showLoader = 0;
        console.error("Failed to fetch teams:", error);
      }
    },
    async getTournamentTeams(guid) {
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/getTournamentTeams`,
          { tournament_guid: guid ? guid : this.tournamentData[0].guid, page: this.page, association_id: this.association_id, } // Include the page parameter
        );

        if (response.data.statusCode === 200) {
          const newData = response.data.data.data;
          newData.sort((a, b) => a.team_sr_no - b.team_sr_no);
          this.teamData = [...this.teamData, ...newData]; // Concatenate the new data with existing data
          this.teamLastPage = response.data.data.last_page;
          this.showLoader = 0;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.showLoader = 0;
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoader = 0;
      } finally {
        this.showLoader = 0;
      }
    },
    manageTeams() {
      this.$root.$emit("openManageTeamsModal", {
        eventId: this.eventId,
        association_id: this.association_id
      });
    },
    filterGames(filter) {
      this.selectedFilter = filter;
      localStorage.setItem('gameFilter', this.selectedFilter);
      this.$root.$emit("FilterGames", this.selectedFilter);
    },
  },
  mounted() {
    this.$root.$on("callJoinTeam", () => {
      this.getJoinTeams();
    });
  },
};
</script>
